// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"oq-z","slideIn":"pq-z"};